import React from 'react'
import * as PropTypes from 'prop-types'
import {claimStatuses, linkedAssets} from '@constants'
import {parseISO, isBefore, startOfDay} from 'date-fns'
const {mapping} = claimStatuses

const CertificateStatus = ({expirationDate, status, type}) => {
  const parsedDate = expirationDate ? parseISO(expirationDate) : null
  const certificateType = linkedAssets.mapping.CERTIFICATE.toUpperCase()
  const statusMapping = {APPROVED: 'tw:success', REQUESTED: 'is-info'}

  if (parsedDate && type === certificateType && isBefore(parsedDate, startOfDay(new Date()))) {
    return (
      <span style={{minWidth: '80px'}} className="tag is-danger">
        <span className="icon is-small">
          <i className="fa-solid fa-ban" />
        </span>
        <span>Expired</span>
      </span>
    )
  } else {
    return (
      <span style={{minWidth: '80px'}} className={`tag ${statusMapping[status]}`}>
        {mapping[status]}
      </span>
    )
  }
}

CertificateStatus.propTypes = {
  status: PropTypes.oneOf(Object.keys(mapping)),
  type: PropTypes.oneOf(Object.keys(linkedAssets.mapping)),
  expirationDate: PropTypes.string,
}

export default CertificateStatus
